<template>
    <div style='margin: 10px'>
        <div class="container-fluid">
            <div class="row" style="height: 200px;">
                <form id="orderItemsUpload" v-if="isInitial || isSaving" 
                    :action="$root.front_end_configs.router_url+'fileupload'" method="post" enctype="multipart/form-data"> 
                    <!--action: defines where the data gets sent-->
                    <!--method: defines how data is sent-->
                    <div class="ddbox">
                        <input type="file" id="file" name="fileToLoad" @change="selectFile" ref="file" class="input-file" :disabled="isSaving" />
                        <p v-if="isInitial">{{$Jed.firstUpperTranslate('Drag your file here or click to browse')}}</p>
                        <p v-if="isSaving">{{file.name}}</p> <!--{{$Jed.firstUpperTranslate('Uploading file...')}}-->
                    </div>
                    <button :disabled="isSyncing" v-if="file" class="btn btn-primary-default" style="margin-top: 15px; margin-right: 15px; float: right;">
                        <input style="border-color: transparent; background-color: inherit;" type="submit">
                    </button>
                </form>
                <div v-if="isSuccess">
                    <h3>{{ uploadedFiles.length }} {{$Jed.translate('file uploaded successfully', uploadedFiles.length)}} </h3>
                    <ul class="list-unstyled">
                        <li v-for="item in uploadedFiles">
                            {{item.name}}
                        </li>
                    </ul>
                    <pre v-if="uploadWarning.length>0" style="margin: 10px 0px; white-space: normal; overflow-y: scroll; height: 90px;">{{$Jed.firstUpperTranslate('warning')}}: {{ uploadWarning }}</pre>
                    <p style="margin: 10px 0px 10px;">
                        <a @click="reset()" style="cursor: pointer;">{{$Jed.firstUpperTranslate('Upload again')}}</a>
                    </p>
                </div>
                <div v-if="isFailed">
                    <h3>{{$Jed.firstUpperTranslate('warning')}}</h3>
                    <pre style="margin: 10px 0px; white-space: normal; overflow-y: scroll; height: 90px;">{{ uploadError }}</pre>
                    <p style="margin: 10px 0px 10px;">
                        <a @click="reset()" style="cursor: pointer;">{{$Jed.firstUpperTranslate('Try again')}}</a>
                    </p>
                </div>
            </div>
            <!--Loader per l'attesa del caricamento-->
            <div v-if="loadingfile" class="sk-cube-grid" style="position: absolute; top: 10px; right: 25px; left: 0px;">
                <div class="sk-cube sk-cube1 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube2 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube3 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube4 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube5 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube6 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube7 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube8 loading-nav-waiter"></div>
                <div class="sk-cube sk-cube9 loading-nav-waiter"></div>
            </div>
            <div class="row" style="height: 20px;"></div>
            <!--<div class="row">
                <div class="col-md-7"></div>
                <div class="col-md-5">
                    <div class="controls col-sm-6">
                    </div>
                    <div class="controls col-sm-6">
                        <button class="btn btn-primary-default" @click.prevent="closeClick" style="width: 100%">{{labels.closeBtnLbl}}</button>
                    </div>
                </div>
            </div>-->
        </div>    
    </div>    
</template>

<script>

import { eventBus } from "../../eventbus";

const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3;

export default {
    props: {
        oid: String
    },
    data: function () {
        var vm = this;
        return {
            labels: {
                closeBtnLbl: vm.$Jed.firstUpperTranslate('close'),
            },
            file: null,
            currentStatus: null,
            uploadedFiles: [],
            ordId: null,
            uploadWarning: '',
            loadingfile: false,
            isSyncing: true
        }
    },
    mounted: function(){
        this.reset();
        var vm = this;
        eventBus.$on('closeUploadModalEvent',()=>{
            vm.closeClick();
        })
    },
    computed: {
      isInitial() {
        return this.currentStatus === STATUS_INITIAL;
      },
      isSaving() {
        return this.currentStatus === STATUS_SAVING;
      },
      isSuccess() {
        return this.currentStatus === STATUS_SUCCESS;
      },
      isFailed() {
        return this.currentStatus === STATUS_FAILED;
      }
    },
    methods: {
        selectFile(){
            this.isSyncing = true
            var fileInput = document.getElementById('file')
            var filePath = fileInput.value;
            // Allowing file type 
            var allowedExtensions = /(\.xls|\.xlsx)$/i; 
              
            if (!allowedExtensions.exec(filePath)) { 
                eventBus.$emit('alert', {
                    message: this.$Jed.firstUpperTranslate('this type of file is not allowed'), 
                    type: "warning" 
                })
                fileInput.value = ''; 
                this.reset()
            }else{ 
                var vm = this;
                this.file = this.$refs.file.files[0]
                this.currentStatus = STATUS_SAVING;
                /* var cartIds = []
                this.$root.shopCartData.prodotti.forEach(p=>{
                    cartIds.push({c: p.codiceProd, q: p.quantita, n: p.noteRiga})
                }) */
                //const formData = new FormData(orderItemsUpload);
                const formData = new FormData();
                formData.append('cmd', 'data.io.Upload')
                formData.append('cmdArgs', JSON.stringify({
                    'type': 'orderItems',
                    //quando apro la finestra di upload l'id dell'ordine mi viene sempre passato come props 
                    //(sia se l'ordine esisteva già, sia se è un nuovo ordine)
                    //se la lascio aperta dopo il primo caricamento, devo usare il nuovo id ordine risposto dal service
                    'recordId': this.ordId ? this.ordId : this.oid, 
                    'lang': this.$Configs.siglaLingua,
                    'defaultLang': this.$Configs.defaultLang,
                    'idU': this.$Configs.idUtente,
                    'idC': this.$Configs.idCliente,
                    'idV': this.$Configs.valuta/* ,
                    'cartIds': cartIds */
                }))
                formData.append('file', this.file)

                var syncBefore = new Promise((resolve, reject)=>{
                    if(!vm.$root.preferences.useOffline){
                        vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                        eventBus.$on('remoteSyncRegistryResolved',()=>{
                            console.log('OK sync')
                            vm.isSyncing = false
                            resolve()
                        })
                    }
                })

                syncBefore.then(()=>{
                    console.log('THEN SYNC BEFORE')
                    //allow form submit only after resolving syncBefore promise
                    orderItemsUpload.onsubmit = async (e) => {
                        e.preventDefault();
                        vm.loadingfile = true
                        fetch(vm.$root.front_end_configs.router_url+'fileupload', {
                            method: 'POST',
                            body: formData,
                            headers: {
                                'Authorization': localStorage.getItem("token")
                            }
                        })
                        .then(response => {
                            if (!response.ok) {
                                throw new Error(response.status);
                            }
                            return response.json();
                        })
                        .then(data=>{
                            console.log(data)
                            var uploadFailed = ''
                            vm.uploadWarning = ''
                            vm.loadingfile = false;
                            if(data.results){
                                this.ordId = data.results[Object.keys(data.results).length-1] //uso l'id del nuovo ordine 
                                for(var r in data.results){
                                    if(data.results[r].errors){
                                        uploadFailed += vm.$Jed.firstUpperTranslate('code')+': '+data.results[r].errors[0].instance.pid+' ('+data.results[r].errors[0].message+')\n'
                                    }
                                    if(typeof data.results[r] == 'string' && data.results[r].includes('diff')){
                                        uploadFailed += vm.$Jed.firstUpperTranslate('code not existing')+': '+data.results[r].split('diff-')[1]+'\n'
                                    }
                                    if(typeof data.results[r] == 'string' && data.results[r].includes('already')){
                                        if(vm.uploadWarning.length == 0){
                                            vm.uploadWarning += vm.$Jed.firstUpperTranslate('code already in cart') +' '
                                            vm.uploadWarning += vm.$Jed.firstUpperTranslate('code')+': '+data.results[r].split('already-')[1]
                                        }else{
                                            vm.uploadWarning += ', '/*+vm.$Jed.firstUpperTranslate('code')+': '*/+data.results[r].split('already-')[1]
                                        }
                                    }
                                }
                                if(uploadFailed.length>0){
                                    vm.uploadError = vm.$Jed.firstUpperTranslate('Some rows were not loaded')+'\n'+ uploadFailed 
                                    vm.currentStatus = STATUS_FAILED;
                                    //per i codici che sono riuscito a caricare, faccio comunque la sync
                                    if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                                }else{
                                    vm.uploadedFiles.push(vm.file);
                                    vm.currentStatus = STATUS_SUCCESS;
                                    if(!vm.$root.preferences.useOffline)vm.$Sync.triggerUpdate() //nuova gestione sync nell'online
                                }
                            }else{
                                if(data.error.includes('quantity not number')){
                                    vm.uploadError = 
                                        vm.$Jed.firstUpperTranslate('Upload failed')+'\n'+
                                        vm.$Jed.firstUpperTranslate('quantity not number', data.val.length) +'\n'+
                                        vm.$Jed.firstUpperTranslate('allowed formats')+'\n'+
                                        vm.$Jed.firstUpperTranslate('product', data.val.length)+": "+data.val;
                                }else if(data.error.includes('code not valid')){
                                    vm.uploadError = 
                                        vm.$Jed.firstUpperTranslate('Upload failed')+'\n'+
                                        vm.$Jed.firstUpperTranslate('code not valid')
                                }else if(data.error.includes('note not valid')){
                                    vm.uploadError = 
                                        vm.$Jed.firstUpperTranslate('Upload failed')+'\n'+
                                        vm.$Jed.firstUpperTranslate('note not valid', data.val.length) +'\n'+
                                        vm.$Jed.firstUpperTranslate('product', data.val.length)+": "+data.val;
                                }else if(data.error == 'no products found'){
                                    vm.uploadError = vm.$Jed.firstUpperTranslate('code not existing')
                                }else{
                                    vm.uploadError = data.error 
                                }
                                vm.currentStatus = STATUS_FAILED;
                            }
                        })
                        .catch(error=>{
                            console.log('CATCH')
                            console.log(error)
                            if(error.message == 415){ //unsupported media type
                                vm.uploadError = vm.$Jed.firstUpperTranslate('this type of file is not supported by the server');
                            }else if(error.message == 406){ //not acceptable
                                vm.uploadError = vm.$Jed.firstUpperTranslate('maximum file or filename size reached %1$s %2$s', null, {key: null, string: [vm.$root.token.upload["orderItems"].fileSize, vm.$root.token.upload["orderItems"].fileNameSize]}, null);
                            }else{
                                vm.uploadError = error
                            }
                            vm.currentStatus = STATUS_FAILED;
                            vm.loadingfile = false;
                        })
                    };
                })
            }
        },
        reset(){
            this.currentStatus = STATUS_INITIAL;
            this.file = ""
            this.uploadedFiles = [];
        },
        wait(ms) {
            return (x) => {
                return new Promise(resolve => setTimeout(() => resolve(x), ms));
            };
        },
        //TODO: ora non viene gestita la chiusura della finestra con la X in alto a destra
        //Conseguenza: se carico il file ma non lo invio, chiudo la finestra, riapro la finestra, carico lo stesso file
        //non lo rileva come cambiato e quindi non parte l'evento @change e quindi non parte il metodo selectFile
        closeClick(){
            this.reset();
        }
    }
}
</script>

<style>
.ddbox{
    outline: 2px dashed grey; /* the dash box */
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px; /* minimum height */
    position: relative;
    cursor: pointer;
}

.input-file{
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
}

.ddbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
}

.ddbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 65px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/others/UploadFile.vue?708cb248